/**
 * Pantalla de carga.
 *
 * Sustituye a los `<div className="center-msg">Cargando…</div>` sueltos, que
 * dejaban un hueco de mil y pico píxeles con una palabra gris en el medio: la
 * página no reservaba nada y al llegar el contenido saltaba entera.
 *
 * Esto dibuja la FORMA de lo que viene, así que el alto ya está tomado y al
 * resolver no se mueve nada. `aria-busy` y el texto para lector de pantalla
 * dicen lo que las cajas grises no pueden decir.
 *
 * Hay dos formas porque hay dos tipos de pantalla, y una lista de tarjetas
 * anunciando una tabla miente sobre lo que está a punto de aparecer:
 * · `tarjetas` — salas y materias: hero, cabecera y rejilla.
 * · `filas`    — panel de administración: cabecera y filas de tabla.
 */
export function Cargando({
  texto = "Cargando…",
  variante = "tarjetas",
  n = 6,
}: {
  texto?: string;
  variante?: "tarjetas" | "filas";
  /** Cuántas piezas fantasma pintar (tarjetas o filas, según la variante). */
  n?: number;
}) {
  return (
    <div className="cargando" aria-busy="true" aria-live="polite">
      <span className="sr-only">{texto}</span>

      {variante === "tarjetas" && <div className="esqueleto esq-hero" />}

      <div className="esqueleto-fila">
        <div className="esqueleto esq-titulo" />
        <div className="esqueleto esq-muted" />
      </div>

      {variante === "tarjetas" ? (
        <div className="esqueleto-grid">
          {Array.from({ length: n }, (_, i) => (
            <div className="esqueleto esq-card" key={i} />
          ))}
        </div>
      ) : (
        <div className="esqueleto-lista">
          {Array.from({ length: n }, (_, i) => (
            <div className="esqueleto esq-row" key={i} />
          ))}
        </div>
      )}
    </div>
  );
}
